module.exports = __webpack_public_path__ + "static/media/aboutus.1f379ee8.jpg";